// extracted by mini-css-extract-plugin
export const lightCard = "cardStyles-module--lightCard--1myhr";
export const darkCard = "cardStyles-module--darkCard--1_APa";
export const gatsbyImageWrapperConstrained = "cardStyles-module--gatsby-image-wrapper-constrained--2T_os";
export const cardText = "cardStyles-module--cardText--1Owf7";
export const darkCardDate = "cardStyles-module--darkCardDate--1uQpD";
export const darkCardText = "cardStyles-module--darkCardText--2vPyf";
export const darkCardDateSpan = "cardStyles-module--darkCardDateSpan--2y7Nq";
export const cardInfo = "cardStyles-module--cardInfo--xt-Lh";
export const category_badge = "cardStyles-module--category_badge--1eIeS";
export const lightCardDate = "cardStyles-module--lightCardDate--MQOIG";
export const darkCardCover = "cardStyles-module--darkCardCover--3Ux37";
export const sectionHeadingText = "cardStyles-module--sectionHeadingText--UU3fe";
export const dark = "cardStyles-module--dark--5vKW9";